(ns cljsjs.react-virtualized
  (:require ["react-virtualized" :as react-virtualized]))

;;npm install react-virtualized
(js/goog.exportSymbol "ReactVirtualized" react-virtualized)
